import { render, staticRenderFns } from "./ListaFormulariosAdocaoPage.vue?vue&type=template&id=3a88bc5c"
import script from "./ListaFormulariosAdocaoPage.vue?vue&type=script&lang=js"
export * from "./ListaFormulariosAdocaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports